import type { ApiSchemas } from '$lib/api/shopwareApi.js';

export interface ProductMediaItemWithUrl {
    id: string;
    type: 'model' | 'video';
    assetUrl: string;
    position: number;
}
export interface ProductMediaItemWithAssetData {
    id: string;
    type: 'media';
    data: NonNullable<ApiSchemas['ProductMedia']['media']>;
    position: number;
}

export type ProductMediaItem = ProductMediaItemWithUrl | ProductMediaItemWithAssetData;
export const productExtraMedia: Record<string, ProductMediaItem[]> = {};
